module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa tỉnh thành",
      "breadcrumbs": [{
        title: 'Quản lý tỉnh thành',
        route: {
          name: 'city'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "createCityForm",
    attrs: {
      "model": _vm.localCity,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitCity('createCityForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localCity.name),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "name", $$v)
      },
      expression: "localCity.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên viết tắt",
      "prop": "short_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên viết tắt"
    },
    model: {
      value: (_vm.localCity.short_name),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "short_name", $$v)
      },
      expression: "localCity.short_name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mã bưu chính ",
      "prop": "code"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mã bưu chính"
    },
    model: {
      value: (_vm.localCity.code),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "code", $$v)
      },
      expression: "localCity.code"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn vùng miền",
      "prop": "region_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn vùng miền"
    },
    model: {
      value: (_vm.localCity.region_id),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "region_id", $$v)
      },
      expression: "localCity.region_id"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn vùng miền",
      "value": 0
    }
  }), _vm._v(" "), _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.id,
      attrs: {
        "label": region.name,
        "value": region.id
      }
    })
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Lấy hàng ",
      "prop": "allow"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.localCity.allow),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "allow", $$v)
      },
      expression: "localCity.allow"
    }
  }, [_vm._v("Lấy hàng")])], 1)], 1), _vm._v(" "), _vm._l((_vm.listCarriers), function(carrier, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 6
      }
    }, [_c('el-form-item', {
      key: _vm.localCity[carrier.key],
      attrs: {
        "label": carrier.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": carrier.name
      },
      model: {
        value: (_vm.localCity[carrier.key]),
        callback: function($$v) {
          _vm.$set(_vm.localCity, carrier.key, $$v)
        },
        expression: "localCity[carrier.key]"
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Danh sách vùng miền"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "multiple": "",
      "filterable": "",
      "placeholder": "Danh sách vùng miền"
    },
    model: {
      value: (_vm.localCity.regions),
      callback: function($$v) {
        _vm.$set(_vm.localCity, "regions", $$v)
      },
      expression: "localCity.regions"
    }
  }, _vm._l((_vm.regions), function(region) {
    return _c('el-option', {
      key: region.id,
      attrs: {
        "label": region.name,
        "value": region.id
      }
    })
  }), 1)], 1)], 1)], 2), _vm._v(" "), _c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Các loại tên",
      "prop": "map_name"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "filterable": "",
      "allow-create": "",
      "default-first-option": "",
      "reserve-keyword": false,
      "placeholder": "Chọn các loại tên cho tỉnh thành phố",
      "no-data-text": "Không có dữ liệu"
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.mapNames),
      callback: function($$v) {
        _vm.mapNames = $$v
      },
      expression: "mapNames"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e2555cb2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/city/EditCity.vue
// module id = 736
// module chunks = 1